import { Table } from "antd"
import type { TableProps } from "antd/es/table"

interface TableExpandableProps<T> extends Omit<TableProps<T>, "expandable"> {
	expandable: TableProps<T>["expandable"]
}

export const TableExpandable = <T extends object>({
	dataSource,
	columns,
	expandable,
	...restProps
}: TableExpandableProps<T>) => {
	return (
		<Table<T> dataSource={dataSource} columns={columns} expandable={expandable} {...restProps} pagination={false} />
	)
}
